export default function Contact() {
  return (
    <section
      id="contact"
      className="section-frame"
    >
      <div className="section-card grid overflow-hidden rounded-[2rem] lg:grid-cols-[0.9fr_1.1fr]" data-aos="fade-up">
        <div className="border-b border-slate-800/70 px-6 py-12 sm:px-10 lg:border-b-0 lg:border-r lg:px-14">
          <div className="section-label">Contact</div>
          <h2 className="section-title mt-6 max-w-md text-slate-50">If my profile matches what your team is looking for, I’d be happy to connect.</h2>
          <p className="section-copy mt-6 max-w-md">
            I am currently open to full-stack developer opportunities in India, especially roles where I can work on real products, improve my skills, and contribute consistently.
          </p>

          <div className="mt-8 flex flex-wrap gap-3">
            <a href="mailto:sivasaikumarkudupudi@gmail.com" className="button-primary">Send Email</a>
            <a href="https://www.linkedin.com/in/siva-sai-kumar-kudupudi-064b4a99" target="_blank" rel="noopener noreferrer" className="button-secondary">LinkedIn</a>
          </div>
        </div>

        <div className="px-6 py-12 sm:px-10 lg:px-14">
          <div className="grid gap-4">
            <div className="glass-chip rounded-[1.5rem] p-5" data-aos="fade-up" data-aos-delay="40">
              <p className="mono text-xs uppercase tracking-[0.3em] text-slate-500">Email</p>
              <a href="mailto:sivasaikumarkudupudi@gmail.com" className="mt-3 block text-lg font-medium text-slate-100 hover:text-sky-300">
                sivasaikumarkudupudi@gmail.com
              </a>
            </div>
            <div className="glass-chip rounded-[1.5rem] p-5" data-aos="fade-up" data-aos-delay="80">
              <p className="mono text-xs uppercase tracking-[0.3em] text-slate-500">LinkedIn</p>
              <a
                href="https://www.linkedin.com/in/siva-sai-kumar-kudupudi-064b4a99"
                target="_blank"
                rel="noopener noreferrer"
                className="mt-3 block text-lg font-medium text-slate-100 hover:text-sky-300"
              >
                linkedin.com/in/siva-sai-kumar-kudupudi-064b4a99
              </a>
            </div>
            <div className="glass-chip rounded-[1.5rem] p-5" data-aos="fade-up" data-aos-delay="120">
              <p className="mono text-xs uppercase tracking-[0.3em] text-slate-500">GitHub</p>
              <a
                href="https://github.com/shivafobl"
                target="_blank"
                rel="noopener noreferrer"
                className="mt-3 block text-lg font-medium text-slate-100 hover:text-sky-300"
              >
                github.com/shivafobl
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
